const FETCH_ATC_AUTH_TOKEN = 'OVID/VISTA360/FETCH_ATC_AUTH_TOKEN_START'
const FETCH_ATC_AUTH_TOKEN_SUCCESS = 'OVID/VISTA360/FETCH_ATC_AUTH_TOKEN_SUCCESS'
const FETCH_ATC_AUTH_TOKEN_FAILED = 'OVID/VISTA360/FETCH_ATC_AUTH_TOKEN_FAILED'

export const constants = {
  FETCH_ATC_AUTH_TOKEN,
  FETCH_ATC_AUTH_TOKEN_SUCCESS,
  FETCH_ATC_AUTH_TOKEN_FAILED,
}
